module.exports = __webpack_public_path__ + "img/img_tag_tddyc.e1569f0f.png";